import type { Config } from '../../types/config';
import type { GetMediaParams } from '../../types/media';
import type { PlaylistItem } from '../../types/playlist';

export default abstract class EntitlementService {
  readonly playbackRetryCount: number = 2;

  abstract getMediaToken(config: Config, mediaId: string, jwt?: string, params?: GetMediaParams, accessType?: string, offerIds?: string[]): Promise<string>;

  async startSession({
    item,
    startTime,
  }: {
    config: Config;
    item: PlaylistItem;
    language?: string;
    jwt?: string;
    accessType?: string;
    offerIds?: string[];
    startTime?: number;
    streamingProtocol?: 'dash' | 'hls';
  }): Promise<{ playableItem: PlaylistItem; startOffset: number }> {
    return { playableItem: item, startOffset: startTime ?? 0 };
  }

  async stopSession(_positionInMs: number): Promise<void> {}
}
